import { Alert } from '@mui/material'
import React from 'react'

import logoGoogle from 'assets/logos/google.svg'
import logoSAML from 'assets/logos/saml.svg'
import { SSOButton } from 'components/authentication/form-fields/SSOButton'
import Button from 'components/common/Button'
import DividerWithText from 'components/common/DividerWithText'
import InputTextField from 'components/common/InputTextField'

export const Password: React.FC<{
  password: string
  signInMethods: string[]
  isLoading: boolean
  signInError: string
  handleSaml: () => void
  handleGoogle: () => void
  handleChange: (e) => void
  googleText?: string
  inputIsDisabled?: boolean
}> = ({
  handleGoogle = () => {},
  handleSaml = () => {},
  googleText,
  signInMethods: methods,
  inputIsDisabled,
  handleChange,
  password,
  isLoading,
  signInError
}) => {
  return (
    <div className="formFields">
      {methods.includes('password') && (
        <div className="formFields">
          <InputTextField
            data-test-password-input
            data-role="login-password"
            disabled={inputIsDisabled}
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={handleChange}
          />
          {signInError && (
            <Alert
              data-testid="sign-in-credentials-error"
              id="signin-error"
              severity="error"
              sx={{ marginBottom: 3 }}
            >
              {signInError}
            </Alert>
          )}
          <Button
            data-test-password-continue-button
            stretch
            data-role="login-submit"
            disabled={!password.length || isLoading}
            label="Continue"
            type="submit"
          />
        </div>
      )}
      {methods.includes('password') && methods.length > 1 && (
        <DividerWithText />
      )}
      {methods.includes('google') && (
        <SSOButton
          data-test-google-signin
          alt="Google"
          logo={logoGoogle}
          text={googleText || 'Log in with Google'}
          onClick={handleGoogle}
        />
      )}
      {methods.includes('saml') && (
        <SSOButton
          data-test-saml-signin
          alt="SAML"
          logo={logoSAML}
          text="Log in with SAML"
          onClick={handleSaml}
        />
      )}
    </div>
  )
}
